import { useEffect, useState } from "react";
import {
  CardHomepage,
  Cardstill,
  GridNew,
  DateInTable,
  DateInBox,
  NewsHeading,
  NewsBox,
  NewsTitle,
  Readmore,
  DateHeading,
  Cardinfo,
} from "./home.style";
import {
  Box,
  Container,
  Grid,
  TableContainer,
  Typography,
} from "@mui/material";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AnnounceNewsCard from "./components/AnnounceNewsCard";
import {
  CarouselArrow,
  CarouselDot,
  CarouselFrame,
  SlidePadding,
} from "./components/announceView.style";
import logo from "../../assets/logo/logotest.png";
import Store from "../../assets/slide-menu.tsx/store";
import Rental from "../../assets/slide-menu.tsx/stall";
import ElectricityBill from "../../assets/slide-menu.tsx/electricity-bill";
import PayBill from "../../assets/slide-menu.tsx/pay-bill";
import SystemLog from "../../assets/slide-menu.tsx/systemLog";
import TrackBill from "../../assets/slide-menu.tsx/track-bill";
import Repair from "../../assets/slide-menu.tsx/repair";
import LeaseHold from "../../assets/slide-menu.tsx/leasehold";
import Certificate from "../../assets/slide-menu.tsx/certificate";
import Sue from "../../assets/slide-menu.tsx/sue";
import Help from "../../assets/slide-menu.tsx/announce";
import CancelContact from "../../assets/slide-menu.tsx/cancel-contact";
import NewsIcon from "../../assets/slide-menu.tsx/News_icon";
import TableRowCommon from "../../component/table/TableRowCommon";
import ModalCustom from "../../component/modalCustom/modalCustom";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";

import { useTranslation } from "react-i18next";
import { routeName } from "../../routes/routers-name";
import { imgs } from "../../constants/images";
import { useHistory } from "react-router-dom";
import AnnounceApi from "../../api/home/announce.api";
import {
  fullDate,
  lnessDatemonth,
  shortnessDate,
} from "../../utils/date.utils";
import { colors } from "../../constants/colors";
import LeaseAgreementApi from "../../api/stall/leaseAgreement/leaseAgreement.api";
import { getBranch, getPermissionMenus, getProfile, setApprove } from "../../utils/app.utils";
import BidderApi from "../../api/stall/bidder/bidder.api";
import { numberFormat } from "../../utils/common";
import _ from "lodash";
import TableCustom from "../../component/table/tableCustom";
import { editProfile } from "../../app/slice/user.slice";
import { useDispatch } from "react-redux";
import { decode } from "js-base64";
import { showModal } from "../../app/slice/modal.slice";
import ModalBlockAccount from "../../component/modalCustom/modalBlockAccount";
import InvoiceApi from "../../api/invoid/invoid.api";
import ModalHaveDept from "../../component/modalCustom/modalHaveDept";
import ApproveApi from "../../api/transferApporve/tranferApprove.api";
import CustomerAgentApi from "../../api/customer-agent/customer-agent.api";
import WalletMoney from "../../assets/slide-menu.tsx/wallet-money";

export default function Home() {
  const history = useHistory();
  const { t } = useTranslation();
  const profile: any = JSON.parse(getProfile() || "{}");
  const branchId: any = getBranch() ? Number(getBranch()) : undefined

  // console.log(branchId);
  const dispatch = useDispatch();
  const [newsData, setNewsData] = useState<any[]>([]);
  const [BookmarkData, getBookmarkData] = useState<any[]>([]);
  const [agreement, setAgreement] = useState<any[]>([]);
  const [bidderData, setBidderData] = useState<any[]>([]);
  const [by_agent, set_by_agent] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1);
  const [rowcount, setRowCount] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(5);
  const [blockAccount, setBlockAccount] = useState<boolean>(false)
  const [depted, setDepted] = useState<boolean>(false)
  const [userId, setUserId] = useState<number>(
    JSON.parse(decode(profile))?.userId
  );
  const [roleId, setRoleId] = useState<number>(
    JSON.parse(decode(profile))?.roleId
  );
  const permissionMenus = getPermissionMenus();
  // console.log(permissionMenus, 'permissionMenus')
  // console.log(by_agent, 'by_agent')

  useEffect(() => {
    setUserId(JSON.parse(decode(profile))?.userId);
    setRoleId(JSON.parse(decode(profile))?.roleId);
    dispatch(editProfile(JSON.parse(decode(profile))));
  }, []);

  const getApprove = async () => {
    await ApproveApi.findRight().then((res: any) => {
      if (res.status == 200) {
        setApprove(res.data)
      }
    });
  };

  useEffect(() => {
    getApprove()
  }, []);

  const getNews = async () => {
    const condition: any = {
      page: 1,
      pageLimit: 50,
      status: "APPROVE",
      sortBy: "createDate",
      sortType: "DESC",
      branchId: branchId
    };
    const res = await AnnounceApi.findAll(condition);
    if (res.status === 200) {
      setRowCount(res?.headers["total"]);
      setNewsData(res.data);
    }
  };

  const getBookmark = async () => {
    const condition: any = {
      // page: 1,
      // pageLimit: 50,
      // status: "APPROVE",
      // sortBy: "createDate",
      // sortType: "DESC",
      branchId: branchId

    };
    const res = await AnnounceApi.findBookmark(condition);
    if (res.status === 200) {
      getBookmarkData(res.data);
    } else {
      getBookmarkData([]);
    }
  };

  useEffect(() => {
    getNews();
    getBookmark();
  }, [page, pageLimit]);

  const getAgreement = async () => {
    const condition: any = {
      page: page,
      pageLimit: pageLimit,
      userId: JSON.parse(decode(profile))?.userId,
      branchId: branchId
    };
    await LeaseAgreementApi.findAll(condition)
      .then((res) => {
        if (res.status === 200) {
          setAgreement(res.data);
        } else {
          setAgreement([]);
        }
      })
      .catch(() => {
        setAgreement([]);
      });
  };
  const get_by_agent = async () => {
    const condition: any = {
      page: page,
      pageLimit: pageLimit,
      customerId_agent: JSON.parse(decode(profile))?.customerId,
    };
    await CustomerAgentApi.by_agent(condition)
      .then((res) => {
        if (res.status === 200) {
          set_by_agent(res.data.data.items);
        } else {
          set_by_agent([]);
        }
      })
      .catch(() => {
        set_by_agent([]);
      });
  };

  useEffect(() => {
    if (JSON.parse(decode(profile))?.roleId === 4) {
      getAgreement();
      get_by_agent()
    }
  }, []);

  const loadBidder = async () => {
    const condition: any = {
      page: page,
      pageLimit: pageLimit,
      userId: JSON.parse(decode(profile))?.userId,
      branchId: branchId
    };
    await BidderApi.findAll(condition)
      .then((res) => {
        if (res.status === 200) {
          setBidderData(res.data);
        } else {
          setBidderData([]);
        }
      })
      .catch(() => {
        setBidderData([]);
      });
  };

  useEffect(() => {
    if (JSON.parse(decode(profile))?.roleId === 4) {
      loadBidder();
    }
  }, []);

  const checkInvoice = async () => {
    const condition: any = {
      page: 1,
      pageLimit: 10,
      userId: JSON.parse(decode(profile))?.userId,
      status: "NOT_PAY",
      branchId: branchId
    }
    const res = await InvoiceApi.findAll(condition)
    if (res.status === 200) {
      if (res.data.length > 4) {
        setBlockAccount(true)
        dispatch(showModal())
      }
      // if (res.data.length > 3 && res.data.length <= 4) {
      //   setDepted(true)
      //   dispatch(showModal())
      // }

    } else {

    }
  }

  useEffect(() => {
    checkInvoice()
  }, [])

  const renderData = (objData: any) => {
    // no = page * pageL  imit - pageLimit + no + 1

    const { startDate, title, announceTypeId, detail, announceId, newsType } =
      objData;

    const objRenderData = {
      key: announceId,
      id: announceId,
      obj: objData,
      columns: [
        {
          option: "COMPONENT",
          align: "center",
          width: 20,
          component: (
            <DateInTable>
              <DateInBox>{shortnessDate(startDate).substring(0, 2)}</DateInBox>
              <DateInBox>{lnessDatemonth(startDate)}</DateInBox>
            </DateInTable>
          ),
        },
        {
          option: "COMPONENT",
          width: 500,
          component: (
            <NewsBox>
              <div className="d-flex flex-row">
                <NewsHeading>{newsType.newstypeNameTh} </NewsHeading>
                <DateHeading>
                  <AccessTimeFilledIcon
                    style={{
                      color: JSON.parse(decode(profile))?.roleId
                        ? JSON.parse(decode(profile))?.roleId == 4
                          ? colors.themeMainColor
                          : colors.themeSecondColor
                        : colors.themeMainColor,
                      marginRight: 8,
                      fontSize: "18px",
                    }}
                  />
                  {t("HOME.TABLE.ANNOUNCE_DATE")} {fullDate(startDate)}
                </DateHeading>
              </div>
              <NewsTitle> {title}</NewsTitle>
            </NewsBox>
          ),
        },

        {
          option: "COMPONENT",
          align: "left",
          component: (
            <NewsBox
              className="d-flex align-item-end"
              onClick={() =>
                history.push(`${routeName.detailinfo}/${announceId}`)
              }
            >
              <Readmore>{t("HOME.TEXT.READ_MORE")}</Readmore>
            </NewsBox>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };


  return (
    <>
      {/* {blockAccount ?
        <ModalBlockAccount />
        : */}
      <CardHomepage>
        {BookmarkData.length !== 0 && (
          <Cardinfo>
            <Container maxWidth="lg">
              <Box sx={{ marginTop: "25px" }}>
                <Typography sx={{ fontSize: "24px" }}>
                  {t("HOME.DETAIL.NEWS")}
                </Typography>
              </Box>
              <CarouselFrame sx={{ marginTop: "24px" }}>
                <Carousel
                  showStatus={false}
                  showThumbs={false}
                  showArrows={BookmarkData.length > 1}
                  showIndicators={BookmarkData.length > 1}
                  autoPlay={BookmarkData.length > 1}
                  infiniteLoop={BookmarkData.length > 1}
                  transitionTime={700}
                  interval={10000}
                  renderArrowPrev={(onClickHandler, hasPrev) =>
                    hasPrev ? (
                      <CarouselArrow onClick={onClickHandler} sx={{ left: 0 }}>
                        <ChevronLeftIcon />
                      </CarouselArrow>
                    ) : null
                  }
                  renderArrowNext={(onClickHandler, hasNext) =>
                    hasNext ? (
                      <CarouselArrow onClick={onClickHandler} sx={{ right: 0 }}>
                        <ChevronRightIcon />
                      </CarouselArrow>
                    ) : null
                  }
                  renderIndicator={(onClickHandler, isSelected, index, label) => (
                    <CarouselDot
                      component="span"
                      selected={isSelected}
                      onClick={onClickHandler}
                      onKeyDown={onClickHandler}
                      key={index}
                      role="button"
                      tabIndex={0}
                      aria-label={`${label} ${index + 1}`}
                    />
                  )}
                >
                  {BookmarkData?.map((e: any, index: number) => (
                    <SlidePadding key={e?.announceId || index}>
                      <AnnounceNewsCard
                        announce={e}
                        counter={`${index + 1} / ${BookmarkData.length}`}
                        onReadMore={() =>
                          history.push(`${routeName.detailinfo}/${e?.announceId}`)
                        }
                      />
                    </SlidePadding>
                  ))}
                </Carousel>
              </CarouselFrame>
            </Container>
          </Cardinfo>
        )}
        {((roleId === 4 && agreement.length !== 0) || (roleId === 4 && by_agent.length > 0) || roleId !== 4) && (
          <Container maxWidth="lg">
            <Box sx={{ marginTop: "25px" }}>
              <Typography
                sx={{
                  fontSize: "24px",
                  textDecoration: "underline",
                  textDecorationColor: JSON.parse(decode(profile))?.roleId
                    ? JSON.parse(decode(profile))?.roleId == 4
                      ? colors.themeMainColor
                      : colors.themeSecondColor
                    : colors.themeMainColor,
                }}
              >
                บริการ
              </Typography>
            </Box>
            <Box
              sx={{
                marginTop: "35px",
                paddingBottom: "35px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <GridNew container spacing={2}>
                {((roleId === 4 && agreement.length !== 0) || roleId !== 4) && _.map(permissionMenus, (value: any) => {
                  return (
                    <>
                      {value?.menuFirstId === 1 && (
                        <Grid item lg={3}>
                          <Cardstill
                            onClick={() => history.push(routeName.marketMap)}
                          >
                            <Store color={colors.themeMainColor} />

                            <Typography sx={{ marginTop: "15px" }}>
                              {t("HOME.MENU.STALL_INFO")}
                            </Typography>
                          </Cardstill>
                        </Grid>
                      )}
                      {value?.menuFirstId === 2 && (
                        <Grid item lg={3}>
                          <Cardstill
                            onClick={() =>
                              history.push(routeName.stallAgreement)
                            }
                          >
                            <Rental />
                            <Typography sx={{ marginTop: "15px" }}>
                              {t("HOME.MENU.CONTRACT")}
                            </Typography>
                          </Cardstill>
                        </Grid>
                      )}
                      {value?.menuFirstId === 3 && (
                        <Grid item lg={3}>
                          <Cardstill
                            onClick={() => history.push(routeName.waterBill)}
                          >
                            <ElectricityBill />
                            <Typography sx={{ marginTop: "15px" }}>
                              {t("HOME.MENU.WATER_ELECTRICT_BILL")}
                            </Typography>
                          </Cardstill>
                        </Grid>
                      )}

                      {value?.menuFirstId === 4 && (
                        <Grid item lg={3}>
                          {" "}
                          <Cardstill
                            onClick={() => history.push(routeName.payBill)}
                          >
                            <PayBill />
                            <Typography sx={{ marginTop: "15px" }}>
                              {t("HOME.MENU.PAY_OFF_DEBT")}
                            </Typography>
                          </Cardstill>
                        </Grid>
                      )}
                      {value?.menuFirstId === 5 && (
                        <Grid item lg={3}>
                          <Cardstill
                            onClick={() => history.push(routeName.trackBill)}
                          >
                            <TrackBill />
                            <Typography sx={{ marginTop: "15px" }}>
                              {t("HOME.MENU.FOLLOW_DEBT")}
                            </Typography>
                          </Cardstill>
                        </Grid>
                      )}
                      {value?.menuFirstId === 6 && (
                        <Grid item lg={3}>
                          <Cardstill
                            onClick={() => history.push(routeName.repair)}
                          >
                            <Repair />
                            <Typography sx={{ marginTop: "15px" }}>
                              {t("HOME.MENU.REPAIR")}
                            </Typography>
                          </Cardstill>
                        </Grid>
                      )}
                      {value?.menuFirstId === 7 && (
                        <Grid item lg={3}>
                          <Cardstill
                            onClick={() =>
                              history.push(routeName.transferStall)
                            }
                          >
                            <LeaseHold />
                            <Typography sx={{ marginTop: "15px" }}>
                              {t("HOME.MENU.TRANSFER")}
                            </Typography>
                          </Cardstill>
                        </Grid>
                      )}

                      {value?.menuFirstId === 8 && (
                        <Grid item lg={3}>
                          <Cardstill
                            onClick={() => history.push(routeName.certificate)}
                          >
                            <Certificate />
                            <Typography sx={{ marginTop: "15px" }}>
                              {t("HOME.MENU.REQUEST_CERTIFICATE")}
                            </Typography>
                          </Cardstill>
                        </Grid>
                      )}
                      {value?.menuFirstId === 9 && (
                        <Grid item lg={3}>
                          <Cardstill
                            onClick={() => history.push(routeName.sue)}
                          >
                            <Sue />
                            <Typography sx={{ marginTop: "15px" }}>
                              {t("HOME.MENU.SUE")}
                            </Typography>
                          </Cardstill>
                        </Grid>
                      )}
                      {value?.menuFirstId === 10 && (
                        <Grid item lg={3}>
                          <Cardstill
                            onClick={() => history.push(routeName.announce)}
                          >
                            <Help />
                            <Typography sx={{ marginTop: "15px" }}>
                              {t("HOME.MENU.HELP")}
                            </Typography>
                          </Cardstill>
                        </Grid>
                      )}
                      {value?.menuFirstId === 14 && (
                        <Grid item lg={3}>
                          <Cardstill
                            onClick={() => history.push(routeName.systemLog)}
                          >
                            <SystemLog />
                            <Typography sx={{ marginTop: "15px" }}>
                              {t("HOME.MENU.SYSTEM_LOG")}
                            </Typography>
                          </Cardstill>
                        </Grid>
                      )}
                      {value?.menuFirstId === 11 && (
                        <Grid item lg={3}>
                          <Cardstill
                            onClick={() =>
                              history.push(routeName.cancelContract)
                            }
                          >
                            <CancelContact />
                            <Typography sx={{ marginTop: "15px" }}>
                              {t("HOME.MENU.CANCEL_CONTRACT")}
                            </Typography>
                          </Cardstill>
                        </Grid>
                      )}
                      {value?.menuFirstId === 10 && (
                        <Grid item lg={3}>
                          <Cardstill
                            onClick={() => history.push(routeName.announce)}
                          >
                            <NewsIcon />
                            <Typography sx={{ marginTop: "15px" }}>
                              {t("HOME.MENU.NEWS")}
                            </Typography>
                          </Cardstill>
                        </Grid>
                      )}

                    </>
                  );
                })}
                {by_agent.length > 0 && (
                  <>
                    <Grid item lg={3}>
                      <Cardstill
                        onClick={() => history.push(routeName.payBill + '-list-agent')}
                      >
                        <WalletMoney />
                        <Typography sx={{ marginTop: "15px" }}>
                          ชำระเงินแทน
                        </Typography>
                      </Cardstill>

                    </Grid>
                    <Grid item lg={3}>
                      <Cardstill
                        onClick={() => history.push(routeName.repair + '-list-agent')}
                      >
                        <WalletMoney />
                        <Typography sx={{ marginTop: "15px" }}>
                          แจ้งซ่อม
                        </Typography>
                      </Cardstill>
                    </Grid>
                  </>

                )}
              </GridNew>
            </Box>
          </Container>
        )}
        {agreement.length === 0 && roleId === 4 && (
          <Container maxWidth="lg">
            <Box sx={{ marginTop: "25px" }}>
              <Typography
                sx={{
                  fontSize: "24px",
                  textDecoration: "underline",
                  textDecorationColor: "green",
                }}
              >
                {t("HOME.TEXT.OTHER_NEWS")}
              </Typography>
            </Box>
            <TableContainer>
              <TableCustom
                headCells={[]}
                customScroll
                page={page}
                pageLimit={pageLimit}
                sortType={"ASC"}
                sortBy=""
                rowCount={rowcount}
                rowsData={_.map(newsData, (d: any) => {
                  return renderData(d);
                })}
                onSort={() => { }}
                setPageLimit={(value) => setPageLimit(value)}
                setPage={(value) => setPage(value)}
              />
            </TableContainer>
          </Container>
        )}
        {/* เปลี่ยนเป็นรายหน้า */}
        {/* {depted ? <ModalHaveDept /> : <></>} */}


      </CardHomepage>
      {/* } */}


    </>
  );
}
